<template>
  <div>
    <no-data v-if="orderData.length === 0" />
    <!-- 订单列表组件-->
    <div class="box-shadow orderList">
      <div v-for="(order, index) in orderData" :key="index" @click="selectCard(order, index)">
        <el-card shadow="hover" :class="{ 'is-selected': orderId === order.sid, marginBottom10: 1 }" body-style="background-color: white;height: 120px;">
          <div slot="header" class="clearfix flex marginBottom10" style="align-items: flex-end">
            <span style="height: 35px; width: 10px;" />
            <span class="marginLeft5 blue fs19"> {{ order.ctopsNo }}</span>&nbsp;
            <span v-if="order.bdelivery === 2">
              <el-tag type="success" effect="dark">自提</el-tag>&nbsp;&nbsp;
            </span>
            <span v-else-if="order.bdelivery === 3">
              <el-tag type="danger" effect="dark">专</el-tag>&nbsp;&nbsp;
            </span>
            <span v-if="order.bpreOrder === 1">
              <el-tag type="warning" effect="dark">预</el-tag>&nbsp;&nbsp;
            </span>
            <span v-if="order.bplatType === 1" style="color: orange;line-height: 22px;">美团闪购</span>
            <span v-else-if="order.bplatType === 2" style="color: #409EFF;line-height: 22px;">饿了么</span>
            <span v-else-if="order.bplatType === 3" style="color: green;line-height: 22px;">京东到家</span>
            <span v-else-if="order.bplatType === 4" style="color: grey;line-height: 22px;">小程序商城</span>
            <span v-else-if="order.bplatType === 6" style="color: grey;line-height: 22px;">Tops订单</span>
            
            <span v-if="order.bstatus === 0" class="marginLeft5 grey" style="line-height: 22px;">{{ order.soverTime }} 已完成&nbsp;</span>
            <span v-else-if="order.bstatus === 1" class="marginLeft5 grey" style="line-height: 22px;">{{ order.sorderTime }} 新订单&nbsp;</span>
            <span v-else-if="order.bstatus === 2" class="marginLeft5 grey" style="line-height: 22px;">{{ order.sorderTime }} 异常订单&nbsp;</span>
            <span v-else-if="order.bstatus === 3" class="marginLeft5 grey" style="line-height: 22px;">催单&nbsp;</span>
            <span v-else-if="order.bstatus === 4" class="marginLeft5 grey" style="line-height: 22px;">配送异常&nbsp;</span>
            <span v-else-if="order.bstatus === 5" class="marginLeft5 grey" style="line-height: 22px;">取消/退款&nbsp;</span>
            <span v-else-if="order.bstatus === 6" class="marginLeft5 grey" style="line-height: 22px;">预订单&nbsp;</span>
            <span v-else-if="order.bstatus === 7" class="marginLeft5 grey" style="line-height: 22px;">待抢单&nbsp;</span>
            <span v-else-if="order.bstatus === 8" class="marginLeft5 grey" style="line-height: 22px;">待取货&nbsp;</span>
            <span v-else-if="order.bstatus === 9" class="marginLeft5 grey" style="line-height: 22px;">配送中&nbsp;</span>
            <span v-else-if="order.bstatus === 10" class="marginLeft5 grey" style="line-height: 22px;">处理中&nbsp;</span>
            <span v-else-if="order.bstatus === 11" class="marginLeft5 grey" style="line-height: 22px;">未知&nbsp;</span>
            <span v-else-if="order.bstatus === 12" class="marginLeft5 grey" style="line-height: 22px;">{{ order.soverTime }} 加单完成&nbsp;</span>
            <span v-else-if="order.bstatus === 13" class="marginLeft5 grey" style="line-height: 22px;">{{ order.soverTime }} 已取消&nbsp;</span>
            <span class="grey" style="line-height: 22px;">
              订单编号：{{ order.corderNo }}
              <el-tooltip content="复制订单编号" placement="top" effect="light">
                <i class="el-icon-document-copy marginRight10" @click.stop="handleCopyOrderNo(order.corderNo)"></i>
              </el-tooltip>
            </span>
            &nbsp;&nbsp;
            <span class="marginLeftAuto marginRight20">
              <el-tooltip content="忽略订单" placement="top" effect="light">
                <i class="el-icon-close marginRight10" @click="handleUpdateStatusClose(order)"></i>
              </el-tooltip>
              <el-tooltip content="订单日志" placement="top" effect="light">
                <i class="el-icon-document marginRight10" @click="handleShowLogOrder(order)"></i>
              </el-tooltip>
              <el-tooltip content="撤回订单" placement="top" effect="light">
                <i v-if="order.bplatType === 6" class="el-icon-back marginRight10"></i>
              </el-tooltip>
              <el-tooltip content="删除订单" placement="top" effect="light">
                <i v-if="order.bplatType === 6" class="el-icon-delete marginRight10"></i>
              </el-tooltip>
              <el-tooltip content="发送短信" placement="top" effect="light">
                <i class="el-icon-s-comment marginRight10" @click="openMessageDialog(order)"></i>
              </el-tooltip>
              <el-tooltip content="发起聊天" placement="top" effect="light">
                <i class="el-icon-service marginRight10 chat-icon" @click.stop="handleStartChat(order)"></i>
              </el-tooltip>
            </span>
          </div>
          <el-row>
            <el-col :span="18">
              <div>
                <span class="marginLeftAuto">
                  <a class="blue">{{ order.sshop }}</a>
                </span>
                <span class="C909399">#{{ order.cplatNo }}</span>
              </div>
              <div v-if="order.ccustomerName">
                <div class="marginTop5">
                  {{ order.ccustomerName }} <a class="blue" @click="callPhone(order.ccustomerPhonePrivate)">{{ order.ccustomerPhonePrivate ? order.ccustomerPhonePrivate.split("_")[0].replace(order.ccustomerPhonePrivate.substr(3, 4), "****") + "_****" : "" }}</a>
                </div>
                <div class="marginTop5">
                  <a class="blue" @click="checkMap(order)">{{ order.ccustomerAddrDetail }}</a>
                  <span v-if="order.sdistance" class="grey">·{{ order.sdistance / 1000 }}公里</span>
                </div>
              </div>
              <!--        <div v-if="order.corderRemark !== undefined && order.corderRemark === ''">用户备注：{{ order.corderRemark }}</div>-->
              <div class="grey marginTop5">
                备注：<span v-if="order.sorderRemark !== '' && order.sorderRemark !== undefined && order.sorderRemark !== null" >{{ order.sorderRemark }}</span>
              </div>
              <div v-if="order.bstatus === 8 || order.bstatus === 9" class="grey marginTop5">
                <div v-if="order.bstatus === 8" class="black marginTop10 marginBottom10">接单成功</div>
                <div v-if="order.bstatus === 9" class="black marginTop10 marginBottom10">配送中</div>
                <div v-if="order.cdeliveryName">
                  配送员: {{ order.cdeliveryName }}, <a class="blue marginLeft5" @click="callPhone(order.cdeliveryPhone)">{{ order.cdeliveryPhone ? order.cdeliveryPhone.split("_")[0].replace(order.cdeliveryPhone.substr(3, 4), "****") + "_****" : "" }}</a>
                  <el-tooltip class="item marginLeft5 pointer" effect="dark" content="点击向骑手发起短信" placement="bottom-start">
                    <span class="iconfont" @click="openMessageDialog(order)">{{ "&#xe612;" }}</span>
                  </el-tooltip>
                </div>
              </div>
              <div v-if="order.bstatus === 2" class="grey marginTop5">
                异常原因：<span>{{ order.serror }}</span>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>
      <el-button v-if="total > orderData.length" style="width: 100%;" :loading="btnLoading" @click="handlePage">加载更多</el-button>
      <el-dialog class="elDialog" :close-on-click-modal="false" title="查看位置" :visible.sync="addrDialogVisible" width="800px" append-to-body>
        <getDeliveryRoutes v-if="addrDialogVisible" :ord="orderInfo" />
      </el-dialog>
      <el-dialog v-if="messageDialogVisible" class="videoDialog" :close-on-click-modal="false" title="发送短信" :visible.sync="messageDialogVisible" width="400px" append-to-body>
        <div class="flex alignItemsCenter marginBottom10">
          <div class="marginRight10">接收号码 :</div>
          <el-input v-model="receivePhone" clearable placeholder="请输入内容"></el-input>
        </div>
        <div class="marginBottom10">
          <div class="marginRight10">短信类型:</div>
          <el-radio v-model="messageType" label="1">地址短信</el-radio>
        </div>
        <div class="marginBottom10">
          <div class="marginRight10">发送内容:</div>
          <el-input type="textarea" :rows="2" v-model="smsContent" readonly></el-input>
        </div>
        <el-row type="flex" justify="end">
          <el-button type="primary" plain @click="onCencer">取 消</el-button>
          <el-button type="primary" @click="sendSMS">确 认</el-button>
        </el-row>
      </el-dialog>
      <el-dialog v-if="closeDialogVisible" class="videoDialog" :close-on-click-modal="false" title="关闭订单" :visible.sync="closeDialogVisible" width="350px" append-to-body>
        <div class="flex alignItemsCenter marginBottom10">确认忽略当前选中的#{{ orderInfo.cplatNo }}订单么?选择"前往自配送"将上传配送信息提升回传率，避免门店被管控？</div>
        <el-row type="flex" justify="end">
          <el-button v-hasPermi="['order:orderProcessing:close']" type="primary" plain @click="handleOrderClose">仅忽略</el-button>
          <el-button @click="handleDeliverySelf">发自配送</el-button>
        </el-row>
      </el-dialog>
    </div>
    <el-dialog v-if="logOrderDialogVisible" :close-on-click-modal="false" title="查看日志" :visible.sync="logOrderDialogVisible" width="1200px" append-to-body>
      <logOrderDialog v-if="logOrderDialogVisible" :order-no="orderInfo.corderNo" @handleClose="logOrderDialogVisible = false" />
    </el-dialog>
  </div>
</template>

<script>
import getDeliveryRoutes from "@/views/order/getDeliveryRoutes.vue";
import clipboard from "@/utils/clipboard.min.js";
import moment from "moment";
import NoData from "@/components/noData.vue";
import logOrderDialog from "@/views/order/dialog/logOrderDialog";
export default {
  name: "orderListForInquiry",
  components: {
    NoData,
    getDeliveryRoutes,
    logOrderDialog,
  },
  data() {
    return {
      addrDialogVisible: false,
      orderInfo: {},
      //弹窗
      orderData: [],
      messageDialogVisible: false,
      closeDialogVisible: false,
      logOrderDialogVisible: false,
      //短信接受电话
      receivePhone: "",
      //短信内容
      messageType: "1",
      orderId: null,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      smsContent: "",
      btnLoading: false,
    };
  },
  methods: {
    handlePage() {
      this.queryParams.pageNum = this.queryParams.pageNum + 1;
      this.btnLoading = true;
      this.topsAjax.get(`${this.baseUrls.third}/queryListInquiry`, this.queryParams).then((res) => {
        this.btnLoading = false;
        this.orderData = [ ...this.orderData, ...res.rows ];
        this.total = res.total;
      });
    },
    changeListData(queryParams) {
      queryParams.pageNum = 1;
      queryParams.pageSize = 10;
      this.queryParams = queryParams;
      this.btnLoading = true;
      this.orderData = [];
      this.topsAjax.get(`${this.baseUrls.third}/queryListInquiry`, this.queryParams).then((res) => {
        this.btnLoading = false;
        this.orderData = res.rows;
        this.total = res.total;
        this.$emit("handleEndSearch");
      });
    },
    onCencer() {
      this.messageDialogVisible = false;
      this.receivePhone = "";
    },
    sendSMS() {
      if (this.receivePhone === "" || this.receivePhone === null) {
        this.$message({ message: "请输入手机号", type: "warning" });
        return;
      }
      this.topsAjax.post(`${this.baseUrls.storeSms}/send/sort`, { storeId: this.orderInfo.rstore, phone: this.receivePhone }).then(() => {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.messageDialogVisible = false;
      });
      this.topsAjax.post(`${this.baseUrls.storeSms}/send/sort3`, { storeId: this.orderInfo.rstore, phone: this.receivePhone }).then(() => {

      });
      //短信接口
    },
    openMessageDialog(order) {
      this.orderInfo = order;
      this.receivePhone = order.sridePhone;
      this.messageDialogVisible = true;
      this.topsAjax.get(`${this.baseUrls.orderStore}/selectById?sid=${order.rstore}`).then((response) => {
        this.smsContent = "温馨提示：" + response.store.cname + "地址：fzqrtech.cn/" + response.store.ccode + "，商家电话：059122188999，请查收。";
      });
    },
    checkMap(orderInfo) {
      this.orderInfo = orderInfo;
      this.addrDialogVisible = true;
    },
    /**
     * 选中卡片
     * @param index
     */
    selectCard(order) {
      this.orderId = order.sid;
      this.$emit("changeListInfoData", order.sid);
    },
    callPhone(toTel) {
      this.$confirm(`是否拨打电话？`, {
        dangerouslyUseHTMLString: true,
      })
        .then((_) => {
          let url = `${this.baseUrls.websocket}/call?phone=${toTel}`;
          let params = {};
          this.topsAjax.get(url, params).then((res) => {
            this.$message.success("请在呼叫中心客户端确认应答。");
          });
        })
        .catch((_) => {});
    },
    handleUpdateStatusClose(order) {
      this.orderInfo = order;
      this.closeDialogVisible = true;
    },
    handleShowLogOrder(order) {
      this.orderInfo = order;
      this.logOrderDialogVisible = true;
    },
    handleDeliverySelf() {
      let url = `${this.baseUrls.third}/close`;
      this.topsAjax.post(url, { orderId: this.orderInfo.sid, type: 2 }).then(() => {
        this.$message.success("自配送成功");
        this.closeDialogVisible = false;
        this.changeListData(this.queryParams);
      });
    },
    handleOrderClose() {
      let url = `${this.baseUrls.third}/close`;
      this.topsAjax.post(url, { orderId: this.orderInfo.sid, type: 1 }).then(() => {
        this.$message.success("关闭成功");
        this.closeDialogVisible = false;
        this.changeListData(this.queryParams);
      });
    },
    handleCopyOrderNo(orderNo) {
      clipboard.copy(orderNo);
      this.$message({
        type: "success",
        message: "复制成功",
      });
    },
    handleStartChat(order) {
      this.$root.$emit('startChat', order.corderNo);
    },
  },
};
</script>

<style lang="scss" scoped>
.labelGray {
  .el-descriptions-item__label:not(.is-bordered-label) {
    color: #909399;
  }

  .el-descriptions-item__container .el-descriptions-item__content,
  .el-descriptions-item__container .el-descriptions-item__label {
    display: inline-flex;
    justify-content: flex-end;
    margin-right: 10px;
  }
}
::v-deep .el-card__header {
  padding: 0px !important;
}
.is-selected {
  /* 选中效果的样式 */
  border-color: #fdc09f;
  background: #FBEEE4;
}
.ordListInfo {
  .el-card__body,
  .el-main {
    padding: 0;
  }

  .el-collapse-item__header {
    height: auto;
    line-height: 20px;
    background-color: rgb(247, 248, 250) !important;
  }

  .el-collapse-item__wrap {
    background-color: rgb(247, 248, 250) !important;
  }
}

.el-collapse-item__content {
  padding-bottom: 0;
}

.el-descriptions--medium:not(.is-bordered) .el-descriptions-item__cell {
  padding-top: 0;
}

.green {
  background-color: #60e722;
}

.center {
  display: flex;
  justify-content: center;
}

.circle {
  width: 25px; /* 圆的直径 */
  height: 25px; /* 圆的直径 */
  border-radius: 50%; /* 使元素成为圆形的关键属性 */
}

.layout {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
  margin-bottom: 5px;
}
</style>
<style lang="scss" scoped>
.circular {
  border-radius: 50%;
}

.chat-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.1);
    filter: brightness(1.2);
  }
}
</style>
